import type { StandingOrders } from './StandingOrders';

export const CZ: Partial<StandingOrders> = {
    showReceiverNameFirst: true,
    daysUntilLastOfMonth: 28,
    daysUntilLastOfMonthSweep: 28,
    standingOrderIntervals: [
        'DAILY',
        'WEEKLY',
        'MONTHLY',
        'QUARTERLY',
        'HALFYEARLY',
        'YEARLY',
        'IRREGULAR',
    ],
    sweepOrderIntervals: ['DAILY', 'WEEKLY', 'MONTHLY', 'QUARTERLY', 'HALFYEARLY', 'YEARLY'],
    allowedStoppages: ['JUNE', 'JULY', 'AUGUST'],
    historyScheduledExecutionDates: true,
};
